import { Component } from '@angular/core';

declare var $: any;
declare var Site: any;

@Component({
  selector: 'app-admin-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppAdminComponent {
  title = 'app';
  constructor() {
    // init webrtc
    // end *************
    // $(document).ready(function($) {
    //   Site.run();
    // });
  }
}



// WEBPACK FOOTER //
// ./src/app/app-admin.component.ts